module.exports = __webpack_public_path__ + "img/identification-badge.0ecf04dc.svg";